import { ref } from 'vue'
import { defineStore } from 'pinia'

const DARK_KEY = 'qone.ui.dark'
const LOCALE_KEY = 'qone.ui.locale'
const DESKTOP_KEY = 'qone.ui.sidebarCollapsed'

export const useUiStore = defineStore('ui', () => {
  const darkMode = ref(localStorage.getItem(DARK_KEY) === 'true')
  const locale = ref<'vi' | 'en'>((localStorage.getItem(LOCALE_KEY) as 'vi' | 'en') || 'vi')
  const desktopCollapsed = ref(localStorage.getItem(DESKTOP_KEY) === 'true')
  const mobileOpen = ref(false)

  function applyTheme() {
    document.documentElement.classList.toggle('app-dark', darkMode.value)
  }

  function applyLocale() {
    document.documentElement.lang = locale.value
  }

  function initialize() {
    applyTheme()
    applyLocale()
  }

  function toggleDarkMode() {
    darkMode.value = !darkMode.value
    localStorage.setItem(DARK_KEY, String(darkMode.value))
    applyTheme()
  }

  function setLocale(value: 'vi' | 'en') {
    locale.value = value
    localStorage.setItem(LOCALE_KEY, value)
    localStorage.setItem('qone.locale', value)
    applyLocale()
  }

  /** ADR-082: ngôn ngữ mặc định của hệ thống, chỉ khi người dùng chưa tự chọn (không lưu vào máy). */
  function applyDefaultLocale(value: string | null | undefined) {
    if (localStorage.getItem(LOCALE_KEY) || (value !== 'vi' && value !== 'en')) return false
    locale.value = value
    applyLocale()
    return true
  }

  function toggleMenu() {
    if (window.innerWidth < 992) mobileOpen.value = !mobileOpen.value
    else {
      desktopCollapsed.value = !desktopCollapsed.value
      localStorage.setItem(DESKTOP_KEY, String(desktopCollapsed.value))
    }
  }

  function closeMobileMenu() {
    mobileOpen.value = false
  }

  return { darkMode, locale, desktopCollapsed, mobileOpen, initialize, toggleDarkMode, setLocale, applyDefaultLocale, toggleMenu, closeMobileMenu }
})
